var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M13.6 35.1h15.6L37 21.6 29.2 8.1H13.6L5.8 21.6l7.7 13.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M13.6 35.1h15.6L37 21.6 29.2 8.1H13.6L5.8 21.6l7.7 13.5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_main",
    cx: 21.4,
    cy: 21.6,
    r: 5.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsSimple);
export default __webpack_public_path__ + "static/media/settingsSimple.a925775f091c946dedbfb80c00a05f9f.svg";
export { ForwardRef as ReactComponent };